import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownRenderService } from '../../services/markdown-render.service';

/**
 * Generic "instruction style" documentation page. Route data supplies the
 * markdown *content* directly (inlined TS constants under
 * ../../content/*.content.ts) and the page title/subtitle, so this one
 * component serves every guide under the Documentation sidebar section
 * (mirrors the reference style of the TRAMS "Application guide" PDF).
 *
 * Content is inlined at build time rather than fetched at runtime from
 * src/assets, since a runtime fetch of a static asset from a nested route
 * proved unreliable across environments (relative-path resolution / hosting
 * differences). Inlining removes that failure mode entirely.
 */
@Component({
  selector: 'app-doc-guide',
  templateUrl: './doc-guide.component.html',
  styleUrls: ['./doc-guide.component.scss'],
  standalone: false
})
export class DocGuideComponent implements OnInit {
  title = '';
  subtitle = '';
  content: SafeHtml = '';
  loading = true;
  error = false;

  constructor(
    private route: ActivatedRoute,
    private markdownRenderService: MarkdownRenderService,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    const data = this.route.snapshot.data;
    this.title = data['title'] ?? 'Documentation';
    this.subtitle = data['subtitle'] ?? '';
    const markdown = data['content'];

    if (!markdown) {
      this.loading = false;
      this.error = true;
      return;
    }

    const html = this.markdownRenderService.render(markdown);
    this.content = this.sanitizer.bypassSecurityTrustHtml(html);
    this.loading = false;
  }
}
